//==============================
// Growing Together
//==============================

// check if fullpage exists to prevent js errors on other pages
if ($('#fullpage').length > 0) {

$(document).ready(function() {

  $('#fullpage').fullpage({
    licenseKey: '8B6C8943-48F944C9-8880390F-FA879A73',
    autoScrolling: true,
    scrollingSpeed: 1000,
    navigation: true,
    navigationPosition: 'right',
    responsiveWidth: 1022,
    responsiveHeight: 700,
    responsiveSlides: true,
    scrollHorizontally: true,
    // scrollHorizontallyKey: 'czIwMTgzOS5ncmlkc2VydmVyLmNvbV80dEdjMk55YjJ4c1NHOXlhWHB2Ym5SaGJHeDVZZGI=', // staging
    scrollHorizontallyKey: 'Y2FycGdyb3dlcnMub3JnX0dVVWMyTnliMnhzU0c5eWFYcHZiblJoYkd4NVdRag==', // live
    // responsiveSlidesKey: 'czIwMTgzOS5ncmlkc2VydmVyLmNvbV9TaGRjbVZ6Y0c5dWMybDJaVk5zYVdSbGN3PT02cDY=', // staging
    responsiveSlidesKey: 'Y2FycGdyb3dlcnMub3JnXzFiZGNtVnpjRzl1YzJsMlpWTnNhV1JsY3c9PTJDQQ==', // live

    afterRender: function() {
      $('.fullpage-text').removeClass('initial-load');
    },

    afterLoad: function(origin, destination, direction) {
      var loadedSection = this;
    },

    onLeave: function(origin, destination, direction) {
      var leavingSection = this;

      if(destination.isFirst == true){
        $('.fullpage-arrow.prev').addClass('disabled');
      }
      else {
        $('.fullpage-arrow.prev').removeClass('disabled');
      }

      if(destination.isLast == true){
        $('.fullpage-arrow.next').addClass('disabled');
      }
      else {
        $('.fullpage-arrow.next').removeClass('disabled');
      }
    }

  });

  //methods
  $.fn.fullpage.setAllowScrolling(true);
});


$('.fullpage-arrow.next, .js-fullpage-next').click(function() {
  fullpage_api.moveSectionDown();
});

$('.fullpage-arrow.prev').click(function() {
  fullpage_api.moveSectionUp();
});

}